export default "__VITE_ASSET__BKv3xrcE__"